import axios, { AxiosProgressEvent } from 'axios'
import { filetypemime } from 'magic-bytes.js'
import { mimetypeToExtension } from '../../constants'

const urlToFile = async ({ url, fileName }: { url: string; fileName: string }) => {
  const { data } = await axios.get(url, { responseType: 'arraybuffer', withCredentials: false })

  return new File([data], fileName)
}

const sliceFile = (file: File, chunkSizeBytes: number) => {
  const chunks: Blob[] = []
  const chunkQuantity = Math.ceil(file.size / chunkSizeBytes)
  for (let i = 0; i < chunkQuantity; i++) {
    const start = i * chunkSizeBytes
    const end = Math.min(file.size, start + chunkSizeBytes)
    chunks.push(file.slice(start, end))
  }
  return chunks
}

const getFileType = (file: File) =>
  new Promise<string[]>((resolve) => {
    const fileReader = new FileReader()
    fileReader.onloadend = (f) => {
      const bytes = new Uint8Array(f.target?.result as ArrayBuffer)
      const fileType = filetypemime(bytes)
      resolve(fileType)
    }
    fileReader.readAsArrayBuffer(file)
  })

const getFileExtension = (file: File) => {
  const extension = file.name.split('.').pop()

  return extension
}

const fetchFileFromUrl = async ({
  url,
  fileName,
  params,
  headers,
  onDownloadProgress
}: {
  url: string
  fileName: string
  params?: Record<string, any>
  headers?: Record<string, any>
  onDownloadProgress?: (progressEvent: AxiosProgressEvent) => void
}) => {
  const { data } = await axios.get(url, {
    params,
    responseType: 'arraybuffer',
    withCredentials: false,
    headers,
    onDownloadProgress
  })

  return new File([data], fileName)
}

const setAudioFileNameFromMagicNumber = async (file: File) => {
  const magicNumber = await getFileType(file)
  const currentExtension = file?.name?.split('.').pop() || ''
  const trueMimeType = magicNumber[0] || file.type
  const trueExtension = mimetypeToExtension(trueMimeType)

  if (trueExtension === currentExtension || !trueMimeType || !trueExtension) {
    return file
  }

  const newFileName = `${file.name.split('.').slice(0, -1).join('.')}.${trueExtension}`
  const fileCopy = new File([file], newFileName, {
    type: trueMimeType
  })
  return fileCopy
}

export const Files = {
  urlToFile,
  sliceFile,
  getFileType,
  fetchFileFromUrl,
  setAudioFileNameFromMagicNumber,
  getFileExtension
}
